import moment from 'moment';
import { connect } from 'react-redux';
import { constant } from '../../../Utils/constants';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import InputComponent from '../../../Widgets/InputComponent';
import { Form, message, DatePicker, TimePicker,Button } from 'antd';

import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitJobPlan
} from '../../../Utils/FormCalls';

const Responsibility = (props) => {
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});

  const schedulingWorkOrderRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await getDeviceList();
        await getOrganisationsList();
        await getSitesList();
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
    }
  }, [props, formObject, translationCache]);

  const handleChange = (value, key) => {
    const updatedFormObject = {
      ...formObject,
      [key]: value
    };
    schedulingWorkOrderRef.current.setFieldsValue(updatedFormObject);
    setFormObject(updatedFormObject);
  };

  const onFinish = async (values) => {
    const payload = {
      ...formObject,
      ...values
    };
    const statusResponse = await submitJobPlan(payload);

    if (statusResponse?.message) {
      message.success(statusResponse.message);
      onReset();
    } else if (statusResponse?.Error) {
      message.error(statusResponse.Error);
    }
  };

  const onReset = () => {
    schedulingWorkOrderRef.current.resetFields();
  };

  return (
    <>
      <Form
        onFinish={onFinish}
        name={'Responsibility'}
        ref={schedulingWorkOrderRef}
        className="jobplan"
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item
            label={translation(translationCache, constant.targetStart)}
            name="TargetStart"
            onChange={(value) => handleChange(value, 'TargetStart')}
            rules={[{ required: false, message: 'Please Input TargetStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.targetFinish)}
            name="TargetFinish"
            onChange={(value) => handleChange(value, 'TargetFinish')}
            rules={[{ required: false, message: 'Please Input TargetFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.actualStart)}
            name="ActualStart"
            onChange={(value) => handleChange(value, 'ActualStart')}
            rules={[{ required: false, message: 'Please Input ActualStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.actualFinish)}
            name="ActualFinish"
            onChange={(value) => handleChange(value, 'ActualFinish')}
            rules={[{ required: false, message: 'Please Input ActualFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.schedulingStart)}
            name="SchedulingStart"
            onChange={(value) => handleChange(value, 'SchedulingStart')}
            rules={[{ required: false, message: 'Please Input SchedulingStart!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.schedulingFinish)}
            name="SchedulingFinish"
            onChange={(value) => handleChange(value, 'SchedulingFinish')}
            rules={[{ required: false, message: 'Please Input SchedulingFinish!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <DatePicker
              placeholder={translation(translationCache, constant.selectDate)}
              format="YYYY-MM-DD HH:mm:ss"
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.duration)}
            name="Duration"
            onChange={(value) => handleChange(value, 'Duration')}
            rules={[{ required: false, message: 'Please Input Duration!' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <TimePicker
              placeholder={translation(translationCache, constant.selectTime)}
              defaultOpenValue={moment('00:00:00', 'HH:mm:ss')}
              style={{ width: '70%' }}
            />
          </Form.Item>

          <Form.Item
            label={translation(translationCache, constant.sequence)}
            name="subSequence"
            onChange={(e) => handleChange(e.target.value, 'Sequence')}
            rules={[{ required: false, message: 'Please Provide Sequence' }]}
            style={{ width: '100%', flex: '50%' }}
          >
            <InputComponent
              placeholder={translation(translationCache, 'Sequence')}
              style={{ width: '70%' }}
            />
          </Form.Item>
        </div>

        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button htmlType="submit">
              {translation(translationCache, constant.save)}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(Responsibility);